import React, { Component } from "react";
import "./Footer.css";

class FooterFixedOnScreen extends Component {
	render() {
		return <div className="footer footer-fixed-on-page footer-with-background">{this.props.children}</div>;
	}
}

export default FooterFixedOnScreen;
